import {invokeApi} from '../bl_libs/invokeApi';

export const registerFingerprintService = (fingerprint_id) => {
    let requestObj = {
        path   : '/pdq3/public/fingerprint/register',
        method : 'POST'
    };
    requestObj['postData'] = {
        fingerprint_id
    };

    return invokeApi(requestObj);
}

export const fetchFingerprintService = (fingerprint_id) => {
    let requestObj = {
        path   : '/pdq3/public/fingerprint/fetch',
        method : 'POST'
    };
    requestObj['postData'] = {
        fingerprint_id
    };

    return invokeApi(requestObj);
}

export const CurationPromptPublicService = (fingerprint_id, user_message) => {
    let requestObj = {
        path   : '/pdq3/public/curation/prompt',
        method : 'POST'
    };
    requestObj['postData'] = {
        fingerprint_id,
        user_message
    };

    return invokeApi(requestObj);
}

export const fetchProgramOutlineService = (fingerprint_id) => {
    let requestObj = {
        path   : '/pdq3/public/outline/fetch',
        method : 'POST'
    };
    requestObj['postData'] = {
        fingerprint_id
    };

    return invokeApi(requestObj);
}

export const removeUnitProgramPublicService = (fingerprint_id, unit_id) => {
    let requestObj = {
        path   : '/pdq3/public/unit/remove',
        method : 'POST',
    };
    requestObj['postData'] = {
        fingerprint_id,
        unit_id
    };

    return invokeApi(requestObj);
}

export const updateProgramStatusPublicService = (fingerprint_id, program_status) => {
    let requestObj = {
        path   : '/pdq3/public/fingerprint/status/update',
        method : 'POST',
    };
    requestObj['postData'] = {
        fingerprint_id,
        program_status
    };

    return invokeApi(requestObj);
}